var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banners.length>0)?_c('div',{class:_vm.componentClasses},_vm._l((_vm.banners),function(banner,index){return _c('app-banner',{key:'banner-'+index,attrs:{"activePages":banner.active_pages,"bannerIndex":index,"image":banner.image,"link":banner.url}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }